import type {
  CatalogEntryResponse,
  CreateCatalogEntryRequest,
  UpdateCatalogEntryRequest,
} from '@tabita/contracts';
import { apiRequest } from './api-client';

export const denominationsApi = {
  list(includeArchived = false) {
    return apiRequest<readonly CatalogEntryResponse[]>('/platform/denominations', {
      query: { includeArchived },
    });
  },

  create(body: CreateCatalogEntryRequest) {
    return apiRequest<CatalogEntryResponse>('/platform/denominations', { method: 'POST', body });
  },

  update(id: string, body: UpdateCatalogEntryRequest) {
    return apiRequest<CatalogEntryResponse>(`/platform/denominations/${id}`, {
      method: 'PATCH',
      body,
    });
  },

  archive(id: string) {
    return apiRequest<{ archived: true }>(`/platform/denominations/${id}/archive`, {
      method: 'POST',
    });
  },

  restore(id: string) {
    return apiRequest<{ restored: true }>(`/platform/denominations/${id}/restore`, {
      method: 'POST',
    });
  },
};
